import { render } from "./BoxingView.vue?vue&type=template&id=b0a05840&scoped=true"
import script from "./BoxingView.vue?vue&type=script&lang=js"
export * from "./BoxingView.vue?vue&type=script&lang=js"

import "./BoxingView.vue?vue&type=style&index=0&id=b0a05840&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a05840"]])

export default __exports__